import { render, staticRenderFns } from "./candidatesItemWidget.vue?vue&type=template&id=62c073a4&scoped=true"
import script from "./candidatesItemWidget.vue?vue&type=script&lang=js"
export * from "./candidatesItemWidget.vue?vue&type=script&lang=js"
import style0 from "./candidatesItemWidget.vue?vue&type=style&index=0&id=62c073a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c073a4",
  null
  
)

export default component.exports